export const fetchTimezone = () => (
  async (dispatch, getState, api) => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    } catch (error) {
      const data = await api({
        apiPath: 'timezone'
      })
      return data.timezone
    }
  }
)
